// import React, { useEffect, useState } from 'react'
// import { Chart as ChartJS, ArcElement, Legend, Colors } from 'chart.js';
// import { Doughnut } from 'react-chartjs-2';

// ChartJS.register(ArcElement, Legend);

// const optionsTasktracker = {
//     responsive: true,
//     plugins: {
//         legend: {
//             display: true,
//             position: 'bottom',
//             labels: {
//                 color: '#9e9e9e'
//             },
//         },
//         // title: {
//         //     display: true,
//         //     fontSize: 20,
//         //     text: 'Task Tracker'
//         // }
//     },
//     cutout: '60%',
// }

// function TasktrackerChart({ taskTrackerChart }) {

//     const totalTasks = (taskTrackerChart?.todo || 0) +
//         (taskTrackerChart?.inprogress || 0) +
//         (taskTrackerChart?.complete || 0) +
//         (taskTrackerChart?.tododelay || 0) +
//         (taskTrackerChart?.inprogressDelay || 0) +
//         (taskTrackerChart?.completeDelay || 0);

//         console.log(totalTasks);


//     const hasData = totalTasks > 0;

//     const data = {
//         labels: ['Todo', 'In Progress', 'Completed', 'Todo Delay','In Progress Delay', 'Delay Completed'],
//         datasets: [
//             {
//                 data: [taskTrackerChart && taskTrackerChart.todo, taskTrackerChart && taskTrackerChart.inprogress, taskTrackerChart && taskTrackerChart.complete, taskTrackerChart && taskTrackerChart.tododelay, taskTrackerChart && taskTrackerChart.inprogressDelay,taskTrackerChart && taskTrackerChart.completeDelay],
//                 backgroundColor: [
//                     'rgb(127, 127, 127)',
//                     'rgb(89, 71, 208)',
//                     'rgb(63, 213, 52)',
//                     'rgb(255, 230, 43)',
//                     'rgb(232, 143, 41)',
//                     'rgb(244, 27, 27)',
//                 ],
//                 borderWidth: 0,
//             },
//         ],
//     };

//     //dark theme image change
//     const [isDarkTheme, setIsDarkTheme] = useState(false);

//     useEffect(() => {
//         // Check for the theme on initial load
//         const currentTheme = document.body.classList.contains("dark-theme");
//         setIsDarkTheme(currentTheme);

//         // Listen for changes to the body's class (if toggling happens outside this component)
//         const observer = new MutationObserver(() => {
//             const updatedTheme = document.body.classList.contains("dark-theme");
//             setIsDarkTheme(updatedTheme);
//         });

//         observer.observe(document.body, { attributes: true, attributeFilter: ["class"] });

//         // Cleanup observer on component unmount
//         return () => observer.disconnect();
//     }, []);
//     //dark theme image change end

//     return (
//         <>
//             <div className='card text-center graph-card h-100 mb-0'>
//                 <div className='card-body'>
//                     <h5 className='card-title mb-2'>Task</h5>
//                     {hasData ?
//                         <div className='chart-wrap'>
//                             <Doughnut options={optionsTasktracker} data={data} />
//                         </div> :
//                         <div className='chart-wrap-nodata'>
//                             <img
//                                 src={
//                                     isDarkTheme
//                                         ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
//                                         : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
//                                 }
//                                 className="img-fluid"
//                                 alt="no-data"
//                             />
//                         </div>
//                     }
//                 </div>
//             </div>
//         </>
//     )
// }

// export default TasktrackerChart



import React, { useEffect, useState, useRef } from 'react';
import { Chart as ChartJS, ArcElement, Legend, Tooltip } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import { useNavigate } from 'react-router-dom';
import ChartPlaceholder from '../../../loader/ChartPlaceholder';
import TaskTrackerAdd from '../../taskManager/tsaktracker/TaskTrackerAdd';
import { UserAuth } from '../../auth/Auth';
import './ChartCards.css';

ChartJS.register(ArcElement, Legend, Tooltip);

const optionsTasktracker = {
    responsive: true,
    plugins: {
        legend: {
            display: true,
            position: 'bottom',
            labels: {
                color: '#9e9e9e',
                align: 'start', // Left-align the labels
                usePointStyle: true,
                padding: 10,
            },
        },
        tooltip: {
            callbacks: {
                label: function (tooltipItem) {
                    const dataset = tooltipItem.dataset;
                    const dataIndex = tooltipItem.dataIndex;
                    const value = dataset.data[dataIndex];
                    const label = tooltipItem.label || tooltipItem.raw;
                    return `${value}`;
                },
            },
        },
    },
    cutout: '60%',
};

function TasktrackerChart({ taskTrackerChart, Loading }) {

    const chartRef = useRef(null);
    const navigate = useNavigate();
    const { MatchPermission, companyInfoGlobal, MDExist, userDetails } = UserAuth();
    const totalTasks =
        (taskTrackerChart?.todo || 0) +
        (taskTrackerChart?.inprogress || 0) +
        (taskTrackerChart?.overdue || 0);

    const hasData = totalTasks > 0;

    const data = {
        labels: [
            'Todo',
            'In Progress',
            'Overdue',
        ],
        datasets: [
            {
                data: [
                    taskTrackerChart?.todo || 0,
                    taskTrackerChart?.inprogress || 0,
                    taskTrackerChart?.overdue || 0,
                ],
                backgroundColor: [
                    'rgb(100, 207, 92)',
                    'rgb(115, 97, 231)',
                    'rgb(232, 77, 77)',

                ],
                borderWidth: 0,
            },
        ],
    };

    // Dark theme image change
    const [isDarkTheme, setIsDarkTheme] = useState(false);

    useEffect(() => {
        const currentTheme = document.body.classList.contains('dark-theme');
        setIsDarkTheme(currentTheme);

        const observer = new MutationObserver(() => {
            const updatedTheme = document.body.classList.contains('dark-theme');
            setIsDarkTheme(updatedTheme);
        });

        observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

        return () => observer.disconnect();
    }, []);

    // Handle chart click to navigate
    const handleChartClick = (event, chartElements) => {
        if (chartElements.length > 0) {
            const index = chartElements[0].index;
            const label = data.labels[index];

            // if (MDExist) {
            //     switch (label) {
            //         case 'Todo':
            //             navigate('/system-task');
            //             break;
            //         case 'In Progress':
            //             navigate('/system-task');
            //             break;
            //         case 'Completed':
            //             navigate('/system-task');
            //             break;
            //         case 'Todo Delay':
            //             navigate('/system-task');
            //             break;
            //         case 'In Progress Delay':
            //             navigate('/system-task');
            //             break;
            //         case 'Delay Completed':
            //             navigate('/system-task');
            //             break;
            //         default:
            //             break;
            //     }
            // } else {
            //     if (userDetails.branch_position === "HOD") {
            //         switch (label) {
            //             case 'Todo':
            //                 navigate('/hod-task');
            //                 break;
            //             case 'In Progress':
            //                 navigate('/hod-task');
            //                 break;
            //             case 'Completed':
            //                 navigate('/hod-task');
            //                 break;
            //             case 'Todo Delay':
            //                 navigate('/hod-task');
            //                 break;
            //             case 'In Progress Delay':
            //                 navigate('/hod-task');
            //                 break;
            //             case 'Delay Completed':
            //                 navigate('/hod-task');
            //                 break;
            //             default:
            //                 break;
            //         }
            //     } else {
            //         switch (label) {
            //             case 'Todo':
            //                 navigate('/task');
            //                 break;
            //             case 'In Progress':
            //                 navigate('/task');
            //                 break;
            //             case 'Completed':
            //                 navigate('/task');
            //                 break;
            //             case 'Todo Delay':
            //                 navigate('/task');
            //                 break;
            //             case 'In Progress Delay':
            //                 navigate('/task');
            //                 break;
            //             case 'Delay Completed':
            //                 navigate('/task');
            //                 break;
            //             default:
            //                 break;
            //         }
            //     }
            // }

            // Navigate to respective page based on clicked segment

        }
    };

    //------------------------------------------------Create task----------------------------------------

    const [showTaskTrackerModal, setShowTaskTrackerModal] = useState(false);
    const handleCloseTaskTrackerModal = () => setShowTaskTrackerModal(false);
    const handleShowTaskTrackerModal = () => setShowTaskTrackerModal(true);
    const [loading, setLoading] = useState(false)

    return (
        <>
            <div className="text-center graph-card h-100 mb-0">
                <div className="card-body">
                    <h6 className="text-muted mb-3">One Time Task</h6>
                    {Loading ?
                        <ChartPlaceholder /> :
                        <>
                            {hasData ? (
                                <div className="chart-wrap">
                                    <Doughnut
                                        ref={chartRef}
                                        options={{
                                            ...optionsTasktracker,
                                            onClick: (event, elements) => handleChartClick(event, elements),
                                        }}
                                        data={data}
                                    />
                                    <p className='mb-0 mt-1'>Select / Deselect legends</p>

                                    {/* <Doughnut ref={chartRef} options={optionsTasktracker} data={data} /> */}
                                </div>
                            ) : (
                                <div className="chart-wrap-nodata">
                                    <img
                                        src={
                                            isDarkTheme
                                                ? `${process.env.PUBLIC_URL}/assets/images/graph-nodata-dark.png`
                                                : `${process.env.PUBLIC_URL}/assets/images/graph-nodata.png`
                                        }
                                        className="img-fluid"
                                        alt="no-data"
                                    />
                                </div>
                            )}
                            {MatchPermission(["Add TaskTracker"]) ?
                                companyInfoGlobal.tasktracker == 1 ?
                                    <div className='mt-2'>
                                        <button className="btn btn-exp-green btn-sm m-auto" type='button' onClick={handleShowTaskTrackerModal}>
                                            <i className="fas fa-file-alt me-2" />
                                            Create
                                        </button>
                                    </div> : "" : ""
                            }
                        </>
                    }
                </div>
            </div>
            <TaskTrackerAdd
                showTaskTrackerModal={showTaskTrackerModal}
                getAllTask={""}
                handleCloseTaskTrackerModal={handleCloseTaskTrackerModal}
                setLoading={setLoading}
            />
        </>
    );
}

export default TasktrackerChart;
